import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/companyData";

export default function QuickContactBanner({
  title = "Lad os tage den første snak om din opgave",
  subtitle = "Uanset om du søger en tømrermester til en mindre reparation, et nyt tag eller en samlet renovering, begynder et godt resultat med en grundig dialog.",
  primaryCtaText = "Få et tilbud",
  primaryCtaLink = "/kontakt",
  secondaryCtaText = "Se vores arbejde",
  secondaryCtaLink = "/galleri"
}) {
  return (
    <section className="py-14 sm:py-18 bg-stone-100 text-stone-900 relative overflow-hidden border-y border-stone-200">
      {/* Subtle texture background */}
      <div className="absolute inset-0 opacity-40 pointer-events-none bg-[radial-gradient(#d6d3d1_1px,transparent_1px)] [background-size:20px_20px]"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="inline-flex items-center space-x-2 px-3.5 py-1 rounded-full bg-red-100/80 text-[#ce0611] text-xs font-semibold uppercase tracking-wider mb-4 border border-red-200">
          <i className="fa-solid fa-phone-volume text-[#ce0611]" aria-hidden="true"></i>
          <span>Uforpligtende rådgivning</span>
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-stone-900 mb-4">
          {title}
        </h2>

        <p className="text-stone-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          {subtitle}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to={primaryCtaLink}
            className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-[#ce0611] hover:bg-[#b0040e] text-white font-semibold text-sm shadow-sm transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            <i className="fa-solid fa-paper-plane mr-2 text-xs" aria-hidden="true"></i>
            <span>{primaryCtaText}</span>
          </Link>

          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="inline-flex items-center justify-center px-6 py-3.5 rounded-full bg-white hover:bg-stone-50 text-stone-900 font-semibold text-sm border border-stone-300 transition-all shadow-2xs"
          >
            <i className="fa-solid fa-phone mr-2 text-[#ce0611]" aria-hidden="true"></i>
            <span className="whitespace-nowrap">Ring: {COMPANY_INFO.phone}</span>
          </a>

          {secondaryCtaLink && (
            <Link
              to={secondaryCtaLink}
              className="inline-flex items-center justify-center px-6 py-3.5 rounded-full bg-stone-200/80 hover:bg-stone-300/80 text-stone-800 font-medium text-sm border border-stone-300 transition-colors"
            >
              <i className="fa-solid fa-images mr-2 text-stone-700" aria-hidden="true"></i>
              <span>{secondaryCtaText}</span>
            </Link>
          )}
        </div>

        <div className="mt-8 pt-6 border-t border-stone-200/90 flex items-center justify-center text-xs text-stone-600">
          <span className="inline-flex items-center">
            <i className="fa-solid fa-location-dot text-[#ce0611] mr-1.5" aria-hidden="true"></i>
            Vi kører ud i Ribe, Esbjerg, Bramming, Skærbæk, Gørding og hele lokalområdet
          </span>
        </div>
      </div>
    </section>
  );
}
